// Columns.js

export const Columns = (openModalAdd, setModalConfirm, modalConfirm) => [
  {
    id: "action",
    name: "ACTION",
    minWidth: "200px",
    selector: (row) => row.name,
    cell: (row) => (
      <div className="flex flex-col">
        <span className="text-sm font-semibold text-cs-dark leading-tight">
          {row.name || "-"}
        </span>
      </div>
    ),
  },
  {
    id: "description",
    name: "DESCRIPTION",
    minWidth: "260px",
    selector: (row) => row.description,
    cell: (row) => (
      <span className="text-xs text-cs-muted line-clamp-2">
        {row.description || "-"}
      </span>
    ),
  },
  {
    id: "actions",
    name: "",
    right: true,
    minWidth: "90px",
    cell: (row) => (
      <div className="flex items-center justify-end gap-2">
        {/* Edit */}
        <button
          type="button"
          onClick={() => openModalAdd(row)}
          className="
            p-1.5 rounded-lg
            hover:bg-cs-primary-soft
            text-cs-muted hover:text-cs-primary
            transition-colors
          "
          title="Edit alert"
        >
          <span className="material-symbols-outlined text-[18px]">
            edit
          </span>
        </button>

        {/* Si después quieres delete:
        <button
          type="button"
          onClick={() =>
            setModalConfirm({
              ...modalConfirm,
              show: true,
              id: row.id,
            })
          }
          className="
            p-1.5 rounded-lg
            hover:bg-cs-primary-soft
            text-cs-danger hover:text-cs-danger
            transition-colors
          "
          title="Delete alert"
        >
          <span className="material-symbols-outlined text-[18px]">
            delete
          </span>
        </button>
        */}
      </div>
    ),
  },
];
